/**
 * Publish rules for agency profile pages.
 * Mirrors Company.getPublished() and the Admin profile-state tooltip.
 */

export const UNPUBLISHED_STATUSES = new Set([
  'NEW',
  'ONBOARDING',
  'INACTIVE',
]);

const hasPublishableFirstName = (firstName) => (
  Boolean(firstName && String(firstName).trim().length > 0)
);

export const isStatusEligibleForPublish = (status) => (
  !!status && !UNPUBLISHED_STATUSES.has(status)
);

/**
 * Effective profile published state: non-blank firstName, eligible status, and stored flag.
 */
export const getEffectivePublished = (partner) => {
  if (!partner) return false;
  return hasPublishableFirstName(partner.firstName)
    && isStatusEligibleForPublish(partner.status)
    && Boolean(partner.published);
};

/**
 * Publish-condition checklist used by the company save modal.
 */
export const validatePartnerPublishState = (partner) => {
  const firstName = hasPublishableFirstName(partner?.firstName);
  const statusEligible = isStatusEligibleForPublish(partner?.status);
  return {
    firstName,
    statusEligible,
    published: firstName && statusEligible && Boolean(partner?.published),
  };
};

/**
 * Sync the stored published flag from firstName + status (clearing TC name unpublishes).
 */
export const syncPartnerPublished = (partner) => {
  partner.published = hasPublishableFirstName(partner.firstName)
    && isStatusEligibleForPublish(partner.status);
  return partner;
};
